import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import instance from "../../store/actions/instance";
import moment from "moment";
// Antd Components
import { Modal, Select, message, TimePicker, DatePicker, Checkbox } from "antd";
import { editExpectedDelivery } from "../../store/actions/orders";

// My components

// Actions

const { Option } = Select;
const { RangePicker } = TimePicker;

class ColumnsModal extends Component {
  save = () => {
    localStorage.setItem(
      "column_settings",
      JSON.stringify(this.props.columnSettings)
    );
    this.props.onClose();
  };

  render() {
    const { visible, config, t, settings } = this.props;

    return (
      <>
        <Modal
          destroyOnClose={true}
          title={
            <div
              className="ant-modal-title"
              style={{
                textAlign: config.direction == "rtl" ? "right" : "left",
              }}
            >
              {t("Edit Columns")}
            </div>
          }
          open={true}
          onCancel={() => this.props.onClose()}
          onOk={() => this.save()}
          okText={t("Okay")}
          cancelText={t("Close")}
          bodyStyle={{
            paddingTop: 0,
            width: "auto",
            padding: "0px 18px",
            textAlign: config.direction == "ltr" ? "left" : "right",
          }}
          width={300}
        >
          <div className="px-2 mb-3 pt-3">
            {this.props.columns
              .filter((c) => c.condition)
              .map((c) => (
                <div key={c.field} style={{ marginBottom: 8 }}>
                  <Checkbox
                    checked={!!this.props.columnSettings[c.field]}
                    onChange={(e) =>
                      this.props.setColumnSettings(c.field, e.target.checked)
                    }
                  >
                    {c.title}
                  </Checkbox>
                </div>
              ))}
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    user: state.auth.username,
    settings: state.auth.settings,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    editExpectedDelivery: (id, start, end, date, user) =>
      dispatch(editExpectedDelivery(id, start, end, date, user)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(ColumnsModal));
